import type { Side } from '@/common/constants';
import { createHistoryStore } from '@/components/datagrid';
import { isFundingEvent, type PNLEntry } from '@/feature/terminal_tables/position/PNLEntry';
import { isLiquidationReason } from '@/utils/liquidationUtils';

/** Quick-filter value that keeps only liquidation entries. */
export const PNL_LIQUIDATED_FILTER = 'liquidated';

const pnlEntryStoreOptions = {
  getKey: (entry: PNLEntry) => entry.uniqueId,
  applyQuickFilter: (row: PNLEntry, quick?: string) => {
    if (quick === 'market') return true;
    if (quick === PNL_LIQUIDATED_FILTER) return isLiquidationReason(row.statusReason);
    return row.side === (quick as Side);
  },
  getMarketId: (row: PNLEntry) => row.marketId,
};

export const usePnLHistoryStore = createHistoryStore<PNLEntry, string>({
  devtoolsName: 'dex-pnl-history',
  ...pnlEntryStoreOptions,
});

/**
 * Funding view over the position history: the same `PNLEntry` rows restricted to
 * funding events at ingest. A separate store instance so the Funding History tab's
 * filters never leak into the P&L History tab and vice versa.
 */
export const useFundingEventsStore = createHistoryStore<PNLEntry, string>({
  devtoolsName: 'dex-funding-events',
  ...pnlEntryStoreOptions,
  ingestFilter: isFundingEvent,
});
